import { type FC } from "react";
import { MediaSelector, type MediaSelectorProps } from "./Selector/MediaSelector";

interface Props extends MediaSelectorProps {
    id: string;
    remove: (id: string) => void;
}

export const MediaLayer: FC<Props> = ({ id, remove, ...props }) => {
    return (
        <MediaSelector
            {...props}
        />
    );
};
